

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Country, State, City } from "country-state-city"; // ✅ NEW import
// import "./EnrollForm.css";
// import { load } from "@cashfreepayments/cashfree-js";
// import Navbar from "../Home/Navbar";
// import Footer from "../Home/Footer";

// const EnrollForm = () => {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     mobile: "",
//     aadhar_number: "",
//      gender: "",          // ✅ new
//   referred_by: "", 

// citizen_type: "Indian",   // default
// passport_number: "",
//     // ✅ new
//     address_type: "",
//     country: "",
//     state: "",
//     city: "",
//     remarks: "",
//     consent: false,
//     code_of_conduct: false,
//   });

//   const [activities, setActivities] = useState([]);
//   const [selectedActivities, setSelectedActivities] = useState([]);
//   const [imagePreview, setImagePreview] = useState(null);
//   const [file, setFile] = useState(null);
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [userId, setUserId] = useState(null);
//   const [verified, setVerified] = useState(false);
//   const [loading, setLoading] = useState(false);
// const [passportFile, setPassportFile] = useState(null);


//    const [countries, setCountries] = useState([]);
//   const [states, setStates] = useState([]);
//   const [cities, setCities] = useState([]);
// // ✅ GUIDE: Aadhaar OTP resend timer
// const [otpTimer, setOtpTimer] = useState(60);
// const [canResendOtp, setCanResendOtp] = useState(false);


//   const [emailOtp, setEmailOtp] = useState("");
// const [emailOtpStage, setEmailOtpStage] = useState(false);
// const [emailVerified, setEmailVerified] = useState(false);


//   useEffect(() => {
//     axios
//       .get("https://api.garudasena.org/api/activities")
//       .then((res) => setActivities(res.data))
//       .catch((err) => console.error(err));

//          // ✅ Load country list
//     setCountries(Country.getAllCountries());
//   }, []);

  
//   // Handle change for selects
//   const handleCountryChange = (e) => {
//     const countryCode = e.target.value;
//     const country = countries.find((c) => c.isoCode === countryCode);
//     setForm({ ...form, country: country.name, state: "", city: "" });
//     setStates(State.getStatesOfCountry(countryCode));
//     setCities([]); // reset cities
//   };

//   const handleStateChange = (e) => {
//     const stateCode = e.target.value;
//     const state = states.find((s) => s.isoCode === stateCode);
//     setForm({ ...form, state: state.name, city: "" });
//     setCities(City.getCitiesOfState(state.countryCode, stateCode));
//   };

//   const handleCityChange = (e) => {
//     const cityName = e.target.value;
//     setForm({ ...form, city: cityName });
//   };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm({ ...form, [name]: type === "checkbox" ? checked : value });
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     setFile(file);
//     setImagePreview(URL.createObjectURL(file));
//   };

// //   const handleActivityChange = (id) => {
// //     if (selectedActivities.includes(id)) {
// //       setSelectedActivities(selectedActivities.filter((item) => item !== id));
// //     } else {
// //       setSelectedActivities([...selectedActivities, id]);
// //     }
// //   };


// const handleActivityChange = (activityText) => {
//   if (selectedActivities.includes(activityText)) {
//     // If already selected, remove it
//     setSelectedActivities(selectedActivities.filter((item) => item !== activityText));
//   } else {
//     // Add new activity text
//     setSelectedActivities([...selectedActivities, activityText]);
//   }
// };


//   // const sendOtp = async () => {
//   //   if (!form.aadhar_number) return alert("Enter Aadhaar number first");
//   //   setLoading(true);
//   //   try {
//   //     const res = await axios.post("https://api.garudasena.org/api/send-aadhar-otp", {
//   //       Aadhar_No: form.aadhar_number,
//   //     });
//   //     if (res.data.ref_id) {
//   //       setOtpSent(true);
//   //       alert("OTP sent successfully to registered Aadhaar mobile.");
//   //     }
//   //   } catch (err) {
//   //     alert("Failed to send OTP");
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

// // ✅ GUIDE: Send Aadhaar OTP with 60s resend timer
// const sendOtp = async () => {
//   if (!form.aadhar_number) return alert("Enter Aadhaar number first");
//   setLoading(true);

//   try {
//     const res = await axios.post(
//       "https://api.garudasena.org/api/send-aadhar-otp",
//       { Aadhar_No: form.aadhar_number }
//     );

//     if (res.data.ref_id) {
//       setOtpSent(true);
//       setCanResendOtp(false);
//       setOtpTimer(60);
//       alert("OTP sent successfully to registered Aadhaar mobile.");
//     }
//   } catch (err) {
//     alert("Failed to send OTP");
//   } finally {
//     setLoading(false);
//   }
// };


// // ✅ GUIDE: Aadhaar OTP countdown logic
// useEffect(() => {
//   if (otpSent && otpTimer > 0) {
//     const timer = setTimeout(() => setOtpTimer((t) => t - 1), 1000);
//     return () => clearTimeout(timer);
//   }
//   if (otpTimer === 0) {
//     setCanResendOtp(true);
//   }
// }, [otpSent, otpTimer]);


//   const verifyOtp = async () => {
//     if (!otp)
//       return alert("Please enter OTP.");
//     setLoading(true);
//     try {
//       const res = await axios.post("https://api.garudasena.org/api/verify-aadhar-otp", {
//         otp,
//         Aadhar_No: form.aadhar_number,
  
//       });
//       if (res.data.message === "Aadhaar Verified") {
//         setVerified(true);
//         alert("Aadhaar verified successfully ✅");
        
//       }
//     } catch (err) {
//       alert("OTP verification failed");
//     } finally {
//       setLoading(false);
//     }
//   };


//     const [cashfree, setCashfree] = useState(null);

//     // Initialize SDK once
//     useEffect(() => {
//         const init = async () => {
//             const cf = await load({ mode: "production" });
//             setCashfree(cf);
//         };
//         init();
//     }, []);




// const handleSubmit = async (e) => {
//   e.preventDefault();

//   // Check if Aadhaar is verified
// if (form.citizen_type === "Indian" && !verified)
//   return alert("Please verify your Aadhaar first!");


//   // Check if consent and code of conduct are agreed
//   if (!form.consent || !form.code_of_conduct) 
//     return alert("Please agree to both consent and code of conduct.");

//   // Ensure profile image is uploaded
//   if (!file) return alert("Please upload your profile image.");

//   setLoading(true);

//   try {
//     // Submit the enrollment form
//     const formData = new FormData();
//     Object.entries(form).forEach(([key, value]) => formData.append(key, value));
//     formData.append("profile_image", file);
//     formData.append("interested_areas", JSON.stringify(selectedActivities));
//     if (form.citizen_type === "NRI") {
 
//   formData.append("passport_image", passportFile);
// }


//     const res = await axios.post("https://api.garudasena.org/api/enroll", formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });

//     if (res.data.success) {
//       // Set user ID for later payment use
//       setUserId(res.data.userId);
      
//       // Stage the email OTP input
//       // setEmailOtpStage(true);
//         // Initiate payment after email verification
//         const paymentResponse = await initiatePayment(userId);

//         if (!paymentResponse.success || !paymentResponse.payment_session_id) {
//           alert("Payment initiation failed");
//           return;
//         }

//         // Check if Cashfree SDK is loaded
//         if (!cashfree) {
//           alert("Cashfree SDK not loaded yet. Please try again.");
//           return;
//         }

//         // Open checkout page
//         cashfree.checkout({
//           paymentSessionId: paymentResponse.payment_session_id,
//           redirectTarget: "_self",
//         });
      
//       alert("Enrollment submitted! OTP sent to your email.");

 
//     }
//   } catch (err) {
//     alert("Submission failed");
//   } finally {
//     setLoading(false);
//   }
// };


//     const initiatePayment = async (userId) => {
//         try {
//             const response = await axios.post(
//                 "https://api.garudasena.org/api/pay",
//                 {
//                     amount: 1008, clientId: userId, Name: form.name,
//                     phone: form.mobile,
//                     email: form.email
//                 }
//             );

//             if (response.data.success && response.data.payment_session_id) {
//                 return { success: true, payment_session_id: response.data.payment_session_id };
//             } else {
//                 return { success: false };
//             }
//         } catch (error) {
//             console.error("Error initiating payment:", error);
//             return { success: false };
//         }
//     };




//   return (
//     <>
//       <Navbar />
//       <div className="enroll-form-container">
//         <h1 className="enroll-title">Garuda Sena Volunteer Enrollment</h1>

//         <form onSubmit={handleSubmit}>
//           <div className="enroll-image-upload">
//             <label>Profile Image:</label>
//             <input
//               type="file"
//               accept="image/*"
//               onChange={handleImageChange}
//               className="enroll-input"
//               required
//             />
//               <small className="helper-text">
//     Please upload a recent passport-size photograph. This image will be used for your ID card.
//   </small>
//             {imagePreview && (
//               <img src={imagePreview} alt="Preview" className="enroll-preview" />
//             )}
//           </div>

//           <input
//             name="name"
//             placeholder="Full Name"
//             onChange={handleChange}
//             required
//             className="enroll-input"
//           />
//           <input
//             name="email"
//             type="email"
//             placeholder="Email"
//             onChange={handleChange}
//             required
//             className="enroll-input"
//           />
//           <input
//             name="mobile"
//             placeholder="Mobile"
//             onChange={handleChange}
//             required
//             className="enroll-input"
//           />
//           {/* ✅ Gender Radio Buttons */}
// <div className="enroll-gender">
//   <label><strong>Gender:</strong></label>
//   <label>
//     <input
//       type="radio"
//       name="gender"
//       value="Male"
//       checked={form.gender === "Male"}
//       onChange={handleChange}
//       required
//     />{" "}
//     Male
//   </label>
//   <label>
//     <input
//       type="radio"
//       name="gender"
//       value="Female"
//       checked={form.gender === "Female"}
//       onChange={handleChange}
//     />{" "}
//     Female
//   </label>
//   <label>
//     <input
//       type="radio"
//       name="gender"
//       value="Other"
//       checked={form.gender === "Other"}
//       onChange={handleChange}
//     />{" "}
//     Other
//   </label>
// </div>

// {/* ✅ Referred By */}
// <input
//   name="referred_by"
//   placeholder="Referred By (Optional)"
//   onChange={handleChange}
//   className="enroll-input"
// />
// {/* Citizen Type Selection */}
// <div className="enroll-citizen" style={{margiTop:10,marginBottom:10}}>
//   <label><strong>Citizenship:</strong></label>

//   <label>
//     <input
//       type="radio"
//       name="citizen_type"
//       value="Indian"
//       checked={form.citizen_type === "Indian"}
//       onChange={handleChange}
//     /> Indian
//   </label>

//   <label>
//     <input
//       type="radio"
//       name="citizen_type"
//       value="NRI"
//       checked={form.citizen_type === "NRI"}
//       onChange={handleChange}
//     /> NRI / Foreigner
//   </label>
// </div>

// {form.citizen_type === "Indian" && (
//           <div className="enroll-aadhaar-section">
//             <input
//               name="aadhar_number"
//               placeholder="Aadhaar Number"
//               onChange={handleChange}
//               maxLength={12}
//               required
//               className="enroll-input"
//             />
//             {/* {!otpSent ? (
//               <button
//                 type="button"
//                 className="enroll-otp-btn"
//                 onClick={sendOtp}
//               >
//                 {loading ? "Sending..." : "Send OTP"}
//               </button>
//             ) : (
//               <>
//                 <input
//                   type="text"
//                   placeholder="Enter OTP"
//                   value={otp}
//                   onChange={(e) => setOtp(e.target.value)}
//                   className="enroll-input"
//                 />
//                 <button
//                   type="button"
//                   onClick={verifyOtp}
//                   className="enroll-button"
//                 >
//                   Verify OTP
//                 </button>
//               </>
//             )} */}

//             {!otpSent ? (
//   <button
//     type="button"
//     className="enroll-otp-btn"
//     onClick={sendOtp}
//   >
//     {loading ? "Sending..." : "Send OTP"}
//   </button>
// ) : (
//   <>
//     <input
//       type="text"
//       placeholder="Enter OTP"
//       value={otp}
//       onChange={(e) => setOtp(e.target.value)}
//       className="enroll-input"
//     />

//     <button
//       type="button"
//       onClick={verifyOtp}
//       className="enroll-button"
//     >
//       Verify OTP
//     </button>

//     {/* ✅ GUIDE: Resend OTP after 60s */}
//     <button
//       type="button"
//       onClick={sendOtp}
//       disabled={!canResendOtp}
//       className="enroll-otp-btn"
//       style={{ marginTop: "8px" }}
//     >
//       {canResendOtp ? "Resend OTP" : `Resend OTP (${otpTimer}s)`}
//     </button>
//   </>
// )}

//             {verified && <span className="enroll-verified-badge">✔ Verified</span>}
//           </div>
// )}

// {form.citizen_type === "NRI" && (
//   <div className="passport-section">
//     <input
//       name="passport_number"
//       placeholder="Passport Number"
//       onChange={handleChange}
//       required
//       className="enroll-input"
//     />

//     <label>Upload Passport Image:</label>
//     <input
//       type="file"
//       accept="image/*"
//       onChange={(e) => setPassportFile(e.target.files[0])}
//       className="enroll-input"
//       required
//     />
//   </div>
// )}

//           <input
//             name="address_type"
//             placeholder="Address"
//             onChange={handleChange}
//             required
//             className="enroll-input"
//           />
//            {/* ✅ Country → State → City Dynamic Selectors */}
//           <select
//             onChange={handleCountryChange}
//             required
//             className="enroll-select"
//             value={
//               countries.find((c) => c.name === form.country)?.isoCode || ""
//             }
//           >
//             <option value="">Select Country</option>
//             {countries.map((c) => (
//               <option key={c.isoCode} value={c.isoCode}>
//                 {c.name}
//               </option>
//             ))}
//           </select>

//           <select
//             onChange={handleStateChange}
//             required
//             className="enroll-select"
//             disabled={!states.length}
//             value={states.find((s) => s.name === form.state)?.isoCode || ""}
//           >
//             <option value="">Select State</option>
//             {states.map((s) => (
//               <option key={s.isoCode} value={s.isoCode}>
//                 {s.name}
//               </option>
//             ))}
//           </select>

//           <select
//             onChange={handleCityChange}
//             required
//             className="enroll-select"
//             disabled={!cities.length}
//             value={form.city}
//           >
//             <option value="">Select City</option>
//             {cities.map((c) => (
//               <option key={c.name} value={c.name}>
//                 {c.name}
//               </option>
//             ))}
//           </select>
//           <h3 className="enroll-title1">Interested Activities</h3>
//           <div className="enroll-activities">
//             {activities.map((act) => (
//               <label key={act.id}>
//                 <input
//                   type="checkbox"
//                   value={act.id}
//                   checked={selectedActivities.includes(act.activity_text)}
//         onChange={() => handleActivityChange(act.activity_text)}
//                   style={{marginBottom:'12px'}}
//                 />
//                 {act.activity_text}
//               </label>
//             ))}
//           </div>

//           <textarea
//             name="remarks"
//             placeholder="Remarks"
//             rows="3"
//             onChange={handleChange}
//             required
//             className="enroll-textarea"
//           />

//           <div className="enroll-checkboxes">
//             <label>
//               <input
//                 type="checkbox"
//                 name="consent"
//                 checked={form.consent}
//                 onChange={handleChange}
//               />
//               I confirm that the information provided is accurate and agree to
//               volunteer in Garuda Sena.
//             </label>
//             <label>
//               <input
//                 type="checkbox"
//                 name="code_of_conduct"
//                 checked={form.code_of_conduct}
//                 onChange={handleChange}
//               />
//               I agree to follow the Code of Conduct — discipline, dignity, and
//               devotion at all times.
//             </label>
//           </div>

//           <button
//             type="submit"
//             disabled={loading}
//             className="enroll-button"
//           >
//             {loading ? "Submitting..." : "Submit Enrollment"}
//           </button>
//         </form>

//         {emailOtpStage && !emailVerified && (
//   <div className="email-verify-section">
//     <h3>Verify Your Email</h3>
//     <input
//       type="text"
//       placeholder="Enter Email OTP"
//       value={emailOtp}
//       onChange={(e) => setEmailOtp(e.target.value)}
//       className="enroll-input"
//     />
//  <button
//   type="button"
//   className="enroll-button"
//   onClick={async () => {
//     try {
//       // Verify Email OTP
//       const res = await axios.post("https://api.garudasena.org/api/verify-email-otp", {
//         email: form.email,
//         otp: emailOtp,
//       });

//       if (res.data.success) {
//         // OTP verified successfully
//         setEmailVerified(true);
//         alert("Email verified successfully ✅");

//         // Initiate payment after email verification
//         const paymentResponse = await initiatePayment(userId);

//         if (!paymentResponse.success || !paymentResponse.payment_session_id) {
//           alert("Payment initiation failed");
//           return;
//         }

//         // Check if Cashfree SDK is loaded
//         if (!cashfree) {
//           alert("Cashfree SDK not loaded yet. Please try again.");
//           return;
//         }

//         // Open checkout page
//         cashfree.checkout({
//           paymentSessionId: paymentResponse.payment_session_id,
//           redirectTarget: "_self",
//         });
//       } else {
//         alert(res.data.message);
//       }
//     } catch (err) {
//       alert("OTP verification failed");
//     }
//   }}
// >
//   Verify and Proceed with Payment
// </button>

//   </div>
// )}
// {emailVerified && (
//   <span className="enroll-verified-badge">✔ Email Verified</span>
// )}

//       </div>
//       <div className="enroll-assistance">
//   <p>
//     Need assistance? 📞 Reach out to us at{" "}
//     <a href="tel:+919666159999" className="enroll-assistance-link">
//       +91 96661 59999
//     </a>
//   </p>
//   <p>
//     or email us at{" "}
//     <a href="mailto:seva@garudasena.org" className="enroll-assistance-link">
//       seva@garudasena.org
//     </a>
//   </p>
// </div>

//       <Footer />
//     </>
//   );
// };

// export default EnrollForm;





import React, { useState, useEffect } from "react";
import axios from "axios";
import { Country, State, City } from "country-state-city"; // ✅ NEW import
import "./EnrollForm.css";
import { load } from "@cashfreepayments/cashfree-js";
import Navbar from "../Home/Navbar";
import Footer from "../Home/Footer";

const EnrollForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    aadhar_number: "",
     gender: "",          // ✅ new
  referred_by: "", 
    registration_type: "General", // General | VIP | Divyangjan


citizen_type: "Indian",   // default
passport_number: "",
    // ✅ new
    address_type: "",
    country: "",
    state: "",
    city: "",
    remarks: "",
    consent: false,
    code_of_conduct: false,
  });

  const [activities, setActivities] = useState([]);
  const [selectedActivities, setSelectedActivities] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [file, setFile] = useState(null);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [userId, setUserId] = useState(null);
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(false);
const [passportFile, setPassportFile] = useState(null);


   const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
// ✅ GUIDE: Aadhaar OTP resend timer
const [otpTimer, setOtpTimer] = useState(60);
const [canResendOtp, setCanResendOtp] = useState(false);


  const [emailOtp, setEmailOtp] = useState("");
const [emailOtpStage, setEmailOtpStage] = useState(false);
const [emailVerified, setEmailVerified] = useState(false);

// ✅ GUIDE: Mobile OTP for VIP
const [mobileOtpSent, setMobileOtpSent] = useState(false);
const [mobileOtp, setMobileOtp] = useState("");
const [mobileVerified, setMobileVerified] = useState(false);


  useEffect(() => {
    axios
      .get("https://api.garudasena.org/api/activities")
      .then((res) => setActivities(res.data))
      .catch((err) => console.error(err));

         // ✅ Load country list
    setCountries(Country.getAllCountries());
  }, []);

  
  // Handle change for selects
  const handleCountryChange = (e) => {
    const countryCode = e.target.value;
    const country = countries.find((c) => c.isoCode === countryCode);
    setForm({ ...form, country: country.name, state: "", city: "" });
    setStates(State.getStatesOfCountry(countryCode));
    setCities([]); // reset cities
  };

  const handleStateChange = (e) => {
    const stateCode = e.target.value;
    const state = states.find((s) => s.isoCode === stateCode);
    setForm({ ...form, state: state.name, city: "" });
    setCities(City.getCitiesOfState(state.countryCode, stateCode));
  };

  const handleCityChange = (e) => {
    const cityName = e.target.value;
    setForm({ ...form, city: cityName });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

//   const handleActivityChange = (id) => {
//     if (selectedActivities.includes(id)) {
//       setSelectedActivities(selectedActivities.filter((item) => item !== id));
//     } else {
//       setSelectedActivities([...selectedActivities, id]);
//     }
//   };


const handleActivityChange = (activityText) => {
  if (selectedActivities.includes(activityText)) {
    // If already selected, remove it
    setSelectedActivities(selectedActivities.filter((item) => item !== activityText));
  } else {
    // Add new activity text
    setSelectedActivities([...selectedActivities, activityText]);
  }
};


  // const sendOtp = async () => {
  //   if (!form.aadhar_number) return alert("Enter Aadhaar number first");
  //   setLoading(true);
  //   try {
  //     const res = await axios.post("https://api.garudasena.org/api/send-aadhar-otp", {
  //       Aadhar_No: form.aadhar_number,
  //     });
  //     if (res.data.ref_id) {
  //       setOtpSent(true);
  //       alert("OTP sent successfully to registered Aadhaar mobile.");
  //     }
  //   } catch (err) {
  //     alert("Failed to send OTP");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

// ✅ GUIDE: Send Aadhaar OTP with 60s resend timer
const sendOtp = async () => {
  if (!form.aadhar_number) return alert("Enter Aadhaar number first");
  setLoading(true);

  try {
    const res = await axios.post(
      "https://api.garudasena.org/api/send-aadhar-otp",
      { Aadhar_No: form.aadhar_number }
    );

    if (res.data.ref_id) {
      setOtpSent(true);
      setCanResendOtp(false);
      setOtpTimer(60);
      alert("OTP sent successfully to registered Aadhaar mobile.");
    }
  } catch (err) {
    alert("Failed to send OTP");
  } finally {
    setLoading(false);
  }
};


// ✅ GUIDE: Aadhaar OTP countdown logic
useEffect(() => {
  if (otpSent && otpTimer > 0) {
    const timer = setTimeout(() => setOtpTimer((t) => t - 1), 1000);
    return () => clearTimeout(timer);
  }
  if (otpTimer === 0) {
    setCanResendOtp(true);
  }
}, [otpSent, otpTimer]);


  const verifyOtp = async () => {
    if (!otp)
      return alert("Please enter OTP.");
    setLoading(true);
    try {
      const res = await axios.post("https://api.garudasena.org/api/verify-aadhar-otp", {
        otp,
        Aadhar_No: form.aadhar_number,
  
      });
      if (res.data.message === "Aadhaar Verified") {
        setVerified(true);
        alert("Aadhaar verified successfully ✅");
        
      }
    } catch (err) {
      alert("OTP verification failed");
    } finally {
      setLoading(false);
    }
  };


    const [cashfree, setCashfree] = useState(null);

    // Initialize SDK once
    useEffect(() => {
        const init = async () => {
            const cf = await load({ mode: "production" });
            setCashfree(cf);
        };
        init();
    }, []);


// ✅ GUIDE: Divyangjan registration (NO PAYMENT)
const submitDivyangjan = async () => {

    // Check Aadhaar verification first
  if (!verified) {
    return alert("Please verify your Aadhaar before submitting!");
  }
    setLoading(true);
  try {
    const formData = new FormData();
    Object.entries(form).forEach(([k, v]) => formData.append(k, v));
    formData.append("profile_image", file);
    formData.append("interested_areas", JSON.stringify(selectedActivities));

    const res = await axios.post(
      "https://api.garudasena.org/api/enroll-divyangjan",
      formData
    );

    if (res.data.success) {
      alert("Registration submitted successfully ✅");
    }
  } catch (e) {
    alert("Submission failed");
  } finally {
    setLoading(false);
  }
};


const handleSubmit = async (e) => {
  e.preventDefault();

  // Check if Aadhaar is verified
// ✅ GUIDE: Aadhaar required for General + Divyangjan (Indian only)
if (
  (form.registration_type === "General" ||
    form.registration_type === "Divyangjan") &&
  form.citizen_type === "Indian" &&
  !verified
) {
  return alert("Please verify your Aadhaar first!");
}



  // Check if consent and code of conduct are agreed
  if (!form.consent || !form.code_of_conduct) 
    return alert("Please agree to both consent and code of conduct.");

  // Ensure profile image is uploaded
  if (!file) return alert("Please upload your profile image.");

  setLoading(true);

  try {
    // Submit the enrollment form
    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => formData.append(key, value));
    formData.append("profile_image", file);
    formData.append("interested_areas", JSON.stringify(selectedActivities));
    if (form.citizen_type === "NRI") {
 
  formData.append("passport_image", passportFile);
}


    const res = await axios.post("https://api.garudasena.org/api/enroll", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (res.data.success) {
      // Set user ID for later payment use
      setUserId(res.data.userId);
      
      // Stage the email OTP input
      // setEmailOtpStage(true);
        // Initiate payment after email verification
        const paymentResponse = await initiatePayment(res.data.userId);

        if (!paymentResponse.success || !paymentResponse.payment_session_id) {
          alert("Payment initiation failed");
          return;
        }

        // Check if Cashfree SDK is loaded
        if (!cashfree) {
          alert("Cashfree SDK not loaded yet. Please try again.");
          return;
        }

        // Open checkout page
        cashfree.checkout({
          paymentSessionId: paymentResponse.payment_session_id,
          redirectTarget: "_self",
        });
      
      alert("Enrollment submitted! OTP sent to your email.");

 
    }
  } catch (err) {
    alert("Submission failed");
  } finally {
    setLoading(false);
  }
};


    const initiatePayment = async (userId) => {
        try {
            const response = await axios.post(
                "https://api.garudasena.org/api/pay",
                {
                    amount: 1008, clientId: userId, Name: form.name,
                    phone: form.mobile,
                    email: form.email
                }
            );

            if (response.data.success && response.data.payment_session_id) {
                return { success: true, payment_session_id: response.data.payment_session_id };
            } else {
                return { success: false };
            }
        } catch (error) {
            console.error("Error initiating payment:", error);
            return { success: false };
        }
    };




  return (
    <>
      <Navbar />
      <div className="enroll-form-container">
        <h1 className="enroll-title">Garuda Sena Volunteer Enrollment</h1>

        <form onSubmit={handleSubmit}>
          <div className="enroll-image-upload">
            <label>Profile Image:</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="enroll-input"
              required
            />
              <small className="helper-text">
    Please upload a recent passport-size photograph. This image will be used for your ID card.
  </small>
            {imagePreview && (
              <img src={imagePreview} alt="Preview" className="enroll-preview" />
            )}
          </div>
{/* ✅ Registration Type Selection */}
<select
  name="registration_type"
  value={form.registration_type}
  onChange={handleChange}
  className="enroll-select"
  required
>
  <option value="General">General Volunteer</option>
  <option value="VIP">VIP Volunteer</option>
  <option value="Divyangjan">Divyangjan</option>
</select>

          <input
            name="name"
            placeholder="Full Name"
            onChange={handleChange}
            required
            className="enroll-input"
          />
          <input
            name="email"
            type="email"
            placeholder="Email"
            onChange={handleChange}
            required
            className="enroll-input"
          />
          {/* <input
            name="mobile"
            placeholder="Mobile"
            onChange={handleChange}
            required
            className="enroll-input"
          /> */}
          <input
  name="mobile"
  placeholder="Mobile"
  onChange={handleChange}
  required
  className="enroll-input"
/>

{/* ✅ VIP Mobile OTP Verification */}
{/* ✅ VIP Mobile OTP Verification */}
{form.registration_type === "VIP" && (
  <div className="vip-otp-section">
    {!mobileOtpSent ? (
      <button
        type="button"
        onClick={async () => {
          await axios.post("https://api.garudasena.org/api/send-whatsapp-otp", {
            mobile: form.mobile,
          });
          setMobileOtpSent(true);
          alert("OTP sent to mobile");
        }}
        className="enroll-otp-btn"
      >
        Send OTP
      </button>
    ) : !mobileVerified ? (
      <>
        <input
          placeholder="Enter Mobile OTP"
          value={mobileOtp}
          onChange={(e) => setMobileOtp(e.target.value)}
          className="enroll-input"
        />
        <button
          type="button"
          onClick={async () => {
            try {
              const res = await axios.post(
                "https://api.garudasena.org/api/verify-whatsapp-otp",
                { mobile: form.mobile, otp: mobileOtp }
              );
              if (res.data.success) {
                setMobileVerified(true);
                alert("Mobile verified ✅");
              }
            } catch (err) {
              alert(err.response?.data?.message || "OTP verification failed ❌");
            }
          }}
          className="enroll-button"
        >
          Verify OTP
        </button>
      </>
    ) : (
      <span className="otp-verified-tag">
        ✅ Mobile Verified
      </span>
    )}
  </div>
)}


          {/* ✅ Gender Radio Buttons */}
<div className="enroll-gender">
  <label><strong>Gender:</strong></label>
  <label>
    <input
      type="radio"
      name="gender"
      value="Male"
      checked={form.gender === "Male"}
      onChange={handleChange}
      required
    />{" "}
    Male
  </label>
  <label>
    <input
      type="radio"
      name="gender"
      value="Female"
      checked={form.gender === "Female"}
      onChange={handleChange}
    />{" "}
    Female
  </label>
  <label>
    <input
      type="radio"
      name="gender"
      value="Other"
      checked={form.gender === "Other"}
      onChange={handleChange}
    />{" "}
    Other
  </label>
</div>

{/* ✅ Referred By */}
<input
  name="referred_by"
  placeholder="Referred By (Optional)"
  onChange={handleChange}
  className="enroll-input"
/>
{/* Citizen Type Selection */}
<div className="enroll-citizen" style={{margiTop:10,marginBottom:10}}>
  <label><strong>Citizenship:</strong></label>

  <label>
    <input
      type="radio"
      name="citizen_type"
      value="Indian"
      checked={form.citizen_type === "Indian"}
      onChange={handleChange}
    /> Indian
  </label>

  <label>
    <input
      type="radio"
      name="citizen_type"
      value="NRI"
      checked={form.citizen_type === "NRI"}
      onChange={handleChange}
    /> NRI / Foreigner
  </label>
</div>

{form.citizen_type === "Indian" &&
  form.registration_type !== "VIP" && (
    <div className="enroll-aadhaar-section">

            <input
              name="aadhar_number"
              placeholder="Aadhaar Number"
              onChange={handleChange}
              maxLength={12}
              required
              className="enroll-input"
            />
            {/* {!otpSent ? (
              <button
                type="button"
                className="enroll-otp-btn"
                onClick={sendOtp}
              >
                {loading ? "Sending..." : "Send OTP"}
              </button>
            ) : (
              <>
                <input
                  type="text"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  className="enroll-input"
                />
                <button
                  type="button"
                  onClick={verifyOtp}
                  className="enroll-button"
                >
                  Verify OTP
                </button>
              </>
            )} */}

            {!otpSent ? (
  <button
    type="button"
    className="enroll-otp-btn"
    onClick={sendOtp}
  >
    {loading ? "Sending..." : "Send OTP"}
  </button>
) : (
  <>
    <input
      type="text"
      placeholder="Enter OTP"
      value={otp}
      onChange={(e) => setOtp(e.target.value)}
      className="enroll-input"
    />

    <button
      type="button"
      onClick={verifyOtp}
      className="enroll-button"
    >
      Verify OTP
    </button>

    {/* ✅ GUIDE: Resend OTP after 60s */}
    <button
      type="button"
      onClick={sendOtp}
      disabled={!canResendOtp}
      className="enroll-otp-btn"
      style={{ marginTop: "8px" }}
    >
      {canResendOtp ? "Resend OTP" : `Resend OTP (${otpTimer}s)`}
    </button>
  </>
)}

            {verified && <span className="enroll-verified-badge">✔ Verified</span>}
          </div>
)}

{form.citizen_type === "NRI" && (
  <div className="passport-section">
    <input
      name="passport_number"
      placeholder="Passport Number"
      onChange={handleChange}
      required
      className="enroll-input"
    />

    <label>Upload Passport Image:</label>
    <input
      type="file"
      accept="image/*"
      onChange={(e) => setPassportFile(e.target.files[0])}
      className="enroll-input"
      required
    />
  </div>
)}

          <input
            name="address_type"
            placeholder="Address"
            onChange={handleChange}
            required
            className="enroll-input"
          />
           {/* ✅ Country → State → City Dynamic Selectors */}
          <select
            onChange={handleCountryChange}
            required
            className="enroll-select"
            value={
              countries.find((c) => c.name === form.country)?.isoCode || ""
            }
          >
            <option value="">Select Country</option>
            {countries.map((c) => (
              <option key={c.isoCode} value={c.isoCode}>
                {c.name}
              </option>
            ))}
          </select>

          <select
            onChange={handleStateChange}
            required
            className="enroll-select"
            disabled={!states.length}
            value={states.find((s) => s.name === form.state)?.isoCode || ""}
          >
            <option value="">Select State</option>
            {states.map((s) => (
              <option key={s.isoCode} value={s.isoCode}>
                {s.name}
              </option>
            ))}
          </select>

          <select
            onChange={handleCityChange}
            required
            className="enroll-select"
            disabled={!cities.length}
            value={form.city}
          >
            <option value="">Select City</option>
            {cities.map((c) => (
              <option key={c.name} value={c.name}>
                {c.name}
              </option>
            ))}
          </select>
          <h3 className="enroll-title1">Interested Activities</h3>
          <div className="enroll-activities">
            {activities.map((act) => (
              <label key={act.id}>
                <input
                  type="checkbox"
                  value={act.id}
                  checked={selectedActivities.includes(act.activity_text)}
        onChange={() => handleActivityChange(act.activity_text)}
                  style={{marginBottom:'12px'}}
                />
                {act.activity_text}
              </label>
            ))}
          </div>

          <textarea
            name="remarks"
            placeholder="Remarks"
            rows="3"
            onChange={handleChange}
            required
            className="enroll-textarea"
          />

          <div className="enroll-checkboxes">
            <label>
              <input
                type="checkbox"
                name="consent"
                checked={form.consent}
                onChange={handleChange}
              />
              I confirm that the information provided is accurate and agree to
              volunteer in Garuda Sena.
            </label>
            <label>
              <input
                type="checkbox"
                name="code_of_conduct"
                checked={form.code_of_conduct}
                onChange={handleChange}
              />
              I agree to follow the Code of Conduct — discipline, dignity, and
              devotion at all times.
            </label>
          </div>

          {/* <button
            type="submit"
            disabled={loading}
            className="enroll-button"
          >
            {loading ? "Submitting..." : "Submit Enrollment"}
          </button> */}
          {/* ✅ General + VIP → normal submit */}
{form.registration_type !== "Divyangjan" && (
  <button type="submit" disabled={loading} className="enroll-button">
    {loading ? "Submitting..." : "Submit Enrollment"}
  </button>
)}

{/* ✅ Divyangjan → no payment */}
{form.registration_type === "Divyangjan" && (
  <button
    type="button"
    onClick={submitDivyangjan}
    disabled={loading}
    className="enroll-button"
  >
    {loading ? "Submitting..." : "Submit Registration"}
  </button>
)}

        </form>

        {emailOtpStage && !emailVerified && (
  <div className="email-verify-section">
    <h3>Verify Your Email</h3>
    <input
      type="text"
      placeholder="Enter Email OTP"
      value={emailOtp}
      onChange={(e) => setEmailOtp(e.target.value)}
      className="enroll-input"
    />
 <button
  type="button"
  className="enroll-button"
  onClick={async () => {
    try {
      // Verify Email OTP
      const res = await axios.post("https://api.garudasena.org/api/verify-email-otp", {
        email: form.email,
        otp: emailOtp,
      });

      if (res.data.success) {
        // OTP verified successfully
        setEmailVerified(true);
        alert("Email verified successfully ✅");

        // Initiate payment after email verification
        const paymentResponse = await initiatePayment(userId);

        if (!paymentResponse.success || !paymentResponse.payment_session_id) {
          alert("Payment initiation failed");
          return;
        }

        // Check if Cashfree SDK is loaded
        if (!cashfree) {
          alert("Cashfree SDK not loaded yet. Please try again.");
          return;
        }

        // Open checkout page
        cashfree.checkout({
          paymentSessionId: paymentResponse.payment_session_id,
          redirectTarget: "_self",
        });
      } else {
        alert(res.data.message);
      }
    } catch (err) {
      alert("OTP verification failed");
    }
  }}
>
  Verify and Proceed with Payment
</button>

  </div>
)}
{emailVerified && (
  <span className="enroll-verified-badge">✔ Email Verified</span>
)}

      </div>
      <div className="enroll-assistance">
  <p>
    Need assistance? 📞 Reach out to us at{" "}
    <a href="tel:+919666159999" className="enroll-assistance-link">
      +91 96661 59999
    </a>
  </p>
  <p>
    or email us at{" "}
    <a href="mailto:seva@garudasena.org" className="enroll-assistance-link">
      seva@garudasena.org
    </a>
  </p>
</div>

      <Footer />
    </>
  );
};

export default EnrollForm;





